module.exports = __webpack_public_path__ + "static/10-first-image-1992-25b7c594a5de2a80251fa31197af4243.jpg";